import { render } from "./SelfReviewPage.vue?vue&type=template&id=f0e39936&scoped=true"
import script from "./SelfReviewPage.vue?vue&type=script&lang=js"
export * from "./SelfReviewPage.vue?vue&type=script&lang=js"

import "./SelfReviewPage.vue?vue&type=style&index=0&id=f0e39936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e39936"]])

export default __exports__